import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SheerIdApiIntegrationPayload } from 'src/app/interface-models/sheer-id-api-interface';
import { CFETILMSheerIdApiConstant } from 'src/app/cfet-core/constants/cfet-ilm-sheerid-api.constant';
import { SheeridApiService } from 'src/app/cfet-core/core-services/sheeridapiservice.service';

@Component({
    selector: 'app-cancel-modal-utf',
    templateUrl: './cancel-modal-utf.component.html',
    styleUrls: ['./cancel-modal-utf.component.scss'],
    standalone: false
})
export class CancelModalUtfComponent extends CfetBaseComponent {

  @Input() openModal: string;
  @Output() closeModal = new EventEmitter<any>();
  url: any;

  constructor(private readonly sheeridApiService: SheeridApiService) { 
      super(); 
    }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
    }
  }

  async cancelApplication(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
        const sheerIdApiIntegrationData = sessionStorage.getItem('sheerIdApiIntegrationData') ? JSON.parse(sessionStorage.getItem('sheerIdApiIntegrationData')) : null;
        if (sheerIdApiIntegrationData) {
          await this.postSheerIdApiIntegrationData(sheerIdApiIntegrationData);
        }
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrl(this.url + '?fnStatus=eligible-pending');
        } else {
          this.redirectUrl(this.url + '&fnStatus=eligible-pending');
        }
      } else {
        // Redirect to the plp page
        const url = environment.plp_page;
        this.redirectUrl(url + '&fnStatus=eligible-pending');
      }
    }
  }

  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

  async postSheerIdApiIntegrationData(sheerIdApiIntegrationData: any) {
        const sheerIdApiPayload: SheerIdApiIntegrationPayload = {
        isActive: 'TRUE',
        company_user_id: sheerIdApiIntegrationData?.company_user_id,
        company_id: 21,
        userid: sheerIdApiIntegrationData?.userid,
        verification: {
          process: CFETILMSheerIdApiConstant.processName,
          phase: {
            name: CFETILMSheerIdApiConstant.ILMDocUpload,
          },
          step: CFETILMSheerIdApiConstant.submitDocuments,
        },
        sheerId: {
          programId: sheerIdApiIntegrationData?.sheerId?.programId,
          verificationId: sheerIdApiIntegrationData?.sheerId?.verificationId,
          status: CFETILMSheerIdApiConstant.SheerIdDocUpload,
        },
        trigger: {
          source: CFETILMSheerIdApiConstant.source,
        },
      };
      await this.sheeridApiService
        .sendSheerIdApiIntegrationData(sheerIdApiPayload)
        .toPromise()
        .then((response: any) => {
          console.log("SheerId API CusVerPendUtfComp integration response----->:", response);
        })
        .catch((error: any) => {
          console.error("SheerId API CusVerPendUtfComp integration error------>:", error);
        });
    }
      
}
